import React, { useState } from 'react';

const Accordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="milestone-container container">
      {items.map((item, index) => (
        <div key={index}>
          {/* Accordion Header */}
          <div
            className={`milestone-category ${activeIndex === index ? 'active-header' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <span className="milestone-title">{index + 1}. {item.title}</span>
            <span className="dropdown-icon">
              {activeIndex === index ? '▴' : '▾'}
            </span>
          </div>

          {/* Accordion Body */}
          {activeIndex === index && (
            <div className="milestone-content">
              <div className="row">
                {item.content?.img && (
                  <div className="col-md-4">
                    <img src={item.content.img} alt={item.title} className="milestone-image" />
                  </div>
                )}
                <div className="col-md-6">
                  <h3 className="milestone-heading">{item.content?.heading}</h3>
                  <div className="milestone-text mt-5">{item.content?.text}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
